var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deleteaccount"}},[_c('div',{staticClass:"ma-auto text-center"},[_c('Logo'),_c('p',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(_vm.$t('account.delete.deleted')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }